import Smart from '@/components/smart';
import type { LLMDropEvent, LLMDropItem } from '@/types/llmDrop';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';


interface LLMManagerProps {
    aitomicShow: boolean;
    externalDropEvent?: LLMDropEvent;
    onDrop?: (items: LLMDropItem[]) => void;
    isDragOverByFileManager?: boolean;
}

const LLMManager: React.FC<LLMManagerProps> = ({ externalDropEvent, onDrop, isDragOverByFileManager }: LLMManagerProps) => {
    const { t } = useTranslation('common');
    const [dropFiles, setDropFiles] = useState<LLMDropItem[]>([]);

    const handleExternalDrop = (items: LLMDropItem[]) => {
        console.log('[LLMManager] dropped items:', items);
        setDropFiles(items);
        onDrop?.(items);
    };

    useEffect(() => {
        if (!externalDropEvent?.items?.length) {
            return;
        }
        handleExternalDrop(externalDropEvent.items);
    }, [externalDropEvent, onDrop]);

    // Show chat interface when LLM is running and we have host/port
    return (
        <div data-drop-zone="llm-manager" className="relative w-full h-full">
            <Smart dropFiles={dropFiles} />
            {isDragOverByFileManager ? (
                <div className="pointer-events-none absolute inset-0 z-50 flex items-center justify-center bg-neutral-300/70 dark:bg-[#404040]/70 border-2 border-dashed border-primary">
                    <span className="text-sm text-primary font-medium">{t('llm_manager.drop_files')}</span>
                </div>
            ) : null}
        </div>
    );
};

export default LLMManager;
